
export enum UserAction {
    REPLACE_USER = 'REPLACE_USER'
  }
  
  export type UserType = {
    googleId: string,
    imageUrl: string,
    email: string,
    name: string,
    givenName:string,
    familyName: string,
    isLogged: boolean,
    teamRole: string,
    league: string,
    tokenId: string,
    id: string | null
    insightRole: string,
    permissions:string[][],
    teamName: string,
    teamShort: string,
    teamId: string,
    sbRole: string
  }

  
  interface ReplaceUserData {
    type: UserAction.REPLACE_USER,
    user: UserType,
  }
  
  export type ReplaceUserActionTypes = ReplaceUserData;